import { Component, OnInit, ElementRef, Input, Output, ChangeDetectorRef } from '@angular/core';
import { SingService } from '../../service/sing.service';
import { Broadcaster } from '../../service/Broadcaster';
import { Http, Response, Headers } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions } from './services/actions.service';
import { SummExpense } from './class/summ-expense';
import { AddCompain } from './class/add-compain';

import { responseSaveExpense } from 'app/components/class/http/res/response-save-expense';

import { updateCategories } from 'app/components/class/broadcaster/update-categories';
import { responseGetExpense } from 'app/components/class/http/res/response-get-expense';
import { responseAddExpense } from 'app/components/class/http/res/response-add-expense';
import { responseGetСategory } from 'app/components/class/http/res/response-get-category';
import { responseUpdateExpensesProduct } from 'app/components/class/http/res/response-update-expenses-product';
import { responseRemoveFileExpense } from 'app/components/class/http/res/response-remove-file-expense';
import { DeleteFileExpense } from 'app/components/rtb/info/class/delete-file-expense';
import { Tab } from './class/tab';
import { GrandTotal } from 'app/components/class/budget/grand-total';
import { File } from 'app/components/class/expense/file';
import { Expense } from 'app/components/class/expense/expense';
import { responseUpdateTargetBudget } from 'app/components/class/http/res/response-update-target-budget';
import { FlightDateSave } from 'app/components/class/expense/flight-date-save';
import { responseActualBudget } from 'app/components/class/http/res/response-update-actual-budget';
import { Rights } from 'app/components/class/rights';
import { requestGetCategory } from 'app/components/class/http/req/request-get-category';
import { EventEmitter } from '@angular/core';
@Component({
  selector: 'app-right-panel',
  templateUrl: './right-panel.component.html',
  styleUrls: ['./right-panel.component.css'],
  providers: [Actions]
})
export class RightPanelComponent implements OnInit {
  @Output() scrollEvent = new EventEmitter<string>();
  @Output() mouseEvent = new EventEmitter<string>();
  @Output() getDataEvent = new EventEmitter<string>();
  data: any;
  categories;
  newCategories;
  rooftops;
  productStrings;
  expense = {
    id: 0,
    targetBudget: 0
  };
  actualExpense = {
    id: 0,
    actualBudget: 0
  }
  productEdit;
  percentages;
  editOpen = false;
  actualEditOpen = false;
  openedEdit;
  openedActualEdit;
  editInput;
  actualEditInput;
  expenseIndexes = {
    category: 0,
    product: 0,
    campaign: 0,
    rooftop: 0
  };
  tester = 0;
  show = "target";
  file;
  uploading = false;
  dropzone;
  actualExpenseOpen:Expense;
  indexFolder:number = 0;
  filename;
  dealerHover;
  month;
  year;
  quarter;
  openedFlights;
  public color: string = '#000000';
  colors = {
    list: ['#000000', '#000000', '#f7f7f7', '#f7f7f7', '#f7f7f7'],
    color: '000000'
  };
  pickerOpen: boolean = false;
  typeMonth;
  create: boolean = false;
  newValue;
  oldValue;
  selectedProduct;
  selectedCategory;
  flightNum;
  totalExpense;
  updateData;
  selectCell;
  infoIcons = [];
  infoOpen = false;
  mediaCategories = [];
  isMediaCat = false;
  selectedColor = 0;
  indexMediaCat = 0;
  addSubProduct:AddCompain = new AddCompain();
  rights:Rights;
  constructor(
    private httpService: SingService,
    private route: ActivatedRoute,
    private broadcaster: Broadcaster,
    private elRef: ElementRef,
    private ref: ChangeDetectorRef,
    private actions: Actions
  ) {

  }

  ngOnInit() {
    this.broadcaster.on<any>('updateMediaCategories').subscribe((data:Array<String>) => {

      this.mediaCategories = data;
    });
    if (this.actions.getAuthData().loggedIn !== "") {
      if (!this.actions.getAuthData().identity) return;
      
      this.rights = this.actions.getAuthData().identity.rights;
    }
    this.checkActualMode();
    Dropzone.autoDiscover = false;
    this.broadcaster.on<any>('sendBudgetData').subscribe(data => {
      this.data = data.data;
      this.typeMonth = data.typeMonth;
      this.categories = data.data.categories;
      this.rooftops = data.data.rooftops;
      this.month = data.date.month;
      this.year = data.date.year;
      this.quarter = data.date.quarter;
      for (let c of this.categories) {
        this.actions.dealerTotals(c, this.rooftops);
        
      }
      this.actions.convertType(data.data);
      this.getPercent();
      this.tester = 100;
      this.getActualTotals(this.categories)
      this.actions.startEditMode = false;
      this.ref.detectChanges();
    });
    this.broadcaster.on<any>('sendNewBudgetData').subscribe(data => {
      this.data = data.data;
      this.typeMonth = data.typeMonth;
      //this.categories = data.data.categories;
      this.rooftops = data.data.rooftops;
      this.month = data.date.month;
      this.year = data.date.year;
      this.quarter = data.date.quarter;
      for (let c of data.data.categories) {
        this.actions.dealerTotals(c, this.rooftops);
      }
      this.actions.convertType(data.data);
    
      if (this.editOpen) {
        this.editOpen = false;
        this.removeHover();
        this.categories[this.expenseIndexes.category].expenses = data.data.categories[this.expenseIndexes.category].expenses;
        this.categories[this.expenseIndexes.category].products[this.expenseIndexes.product] = data.data.categories[this.expenseIndexes.category].products[this.expenseIndexes.product];   
      }
      if (this.actualEditOpen) {
        this.actualEditOpen = false;
        this.removeHover();
      
        let indexCat:number = Number(this.actualEditInput.getAttribute("categoryIndex"));
        let indexProd:number = Number(this.actualEditInput.getAttribute("productIndex"));
        this.categories[indexCat].expenses = data.data.categories[indexCat].expenses;
        this.categories[indexCat].products[indexProd] = data.data.categories[indexCat].products[indexProd];   
    
      
        }
        this.getPercent();
        this.getActualTotals(this.categories);
      this.actions.startEditMode = false;
      this.ref.detectChanges();
    })
    this.broadcaster.on<any>('changeActualBudget').subscribe(data => {
      this.showActual();
      if (this.editOpen) {
        this.editInput.classList.add('hid');
        this.editOpen = false;
        this.removeHover();
      }
      if (this.actualEditOpen) {
        this.actualEditInput.classList.add('hid');
        this.actualEditOpen = false;
        this.removeHover();
      }
    });
    this.broadcaster.on<any>('addCategoryMenu').subscribe(data => {
      let catColor = document.querySelector('.addCategoryColor');
      if (data.data === 'open' && catColor !== null) {
        document.querySelector('.addCategoryColor').classList.remove('hid');
      } else if (catColor !== null) {
        document.querySelector('.addCategoryColor').classList.add('hid')
      }
    })
    this.broadcaster.on<any>('createNewCategory').subscribe(data => {
      //this.categories.push(data.data);
      this.data.categories.push(data.data);
      this.data.categories.sort(function (a, b) {
        return a.ordinal - b.ordinal;
      });
      //this.convertType(this.data);
      //this.getPercent();
      //this.getActualTotals(this.categories);
    })
    this.broadcaster.on<any>('infoClosed').subscribe(data => {
      if (this.editInput !== undefined) {
        this.editInput.classList.add('hid');
      }
      for (let i of this.infoIcons) {
        if (i) {
          i.classList.remove('orange');
        }

      }
      this.infoOpen = false;
      this.editOpen = false;
      this.removeHover();
      this.actions.closedEditExpense();
    })
    this.elRef.nativeElement.querySelector('.mask-confirm-add-subproduct').addEventListener("click", (event) => {
      this.closedAddSubproduct();
    }, false);

  /*  this.elRef.nativeElement.addEventListener(
      'keyup',
      (event) => {
          if (event.which == 9) {
            console.log('------------------------------------- 1 ------------------------------------');
             this.actions.onInitTab(event,this.rooftops,this.editOpen);
          }
      });*/
  }
  checkActualMode() {
    if (window.localStorage.getItem('actualMode') && window.localStorage.getItem('actualMode') === "actual")
    {
    
    /*  this.broadcaster.broadcast("changeActualBudget", {
        data: "changing actual budget"
      })*/
      this.show = "actual";
    } 

  }
  trackByIndex(index, item) {
    return index;
}
callOnLastIteration() {
  if (this.actions.startEditMode) return;
  this.actions.startEditMode = true;
 
  if (this.show === "actual") {
  
      let edits = document.getElementsByClassName('editIcon');
      for (var i = 0; i < edits.length; i++) {
        edits[i].classList.remove("hid");
        edits[i].classList.add("showing");
      }
      let actual = [].slice.call(document.getElementsByClassName('actual'));
      let target = [].slice.call(document.getElementsByClassName('target'));
     
        for (var i = 0; i < actual.length; i++) {
          actual[i].classList.remove("hid");
          actual[i].classList.add("showing");
          if (target[i]) {
            target[i].classList.add("hid");
          }
        
        }  
   
  
}
if (this.actions.onInitTabAction && this.actions.actual_tab !== null) {
  this.actions.onInitTabAction = false;
  this.actions.actual_tab.rooftop++;
  this.actions.tableIndex++;
  if (this.actions.tableIndex === this.rooftops.length) {
    this.actions.tableIndex = 0;
  }
 
  if (this.actions.actual_tab.sIndex !== undefined) {
    if (this.categories[this.actions.actual_tab.cIndex].products[this.actions.actual_tab.pIndex].subproducts[this.actions.actual_tab.sIndex].expenses[this.actions.tableIndex].id === 0) return;
    this.actions.tableFieldId = this.categories[this.actions.actual_tab.cIndex].products[this.actions.actual_tab.pIndex].subproducts[this.actions.actual_tab.sIndex].id;

    this.actualEditInput = this.elRef.nativeElement.querySelector(`.editInput[subproduct="${this.actions.tableFieldId}"][tabindex="${this.actions.tableIndex}"]`);
  } else  {
    if (this.categories[this.actions.actual_tab.cIndex].products[this.actions.actual_tab.pIndex].expenses[this.actions.tableIndex].id === 0) return;
    this.actions.tableFieldId = this.categories[this.actions.actual_tab.cIndex].products[this.actions.actual_tab.pIndex].id;

    this.actualEditInput = this.elRef.nativeElement.querySelector(`.editInput[subproduct="${this.actions.tableFieldId}"][tabindex="${this.actions.tableIndex}"]`);
     }
  this.openedActualEdit = this.actualEditInput.parentNode.querySelector('.actual');

  let num = this.openedActualEdit.innerText.replace(/[^0-9\.]+/g, "");
  this.actualEditInput.value = num;
  if (this.actualEditInput.value === "0") {
    this.actualEditInput.value = "";
  }
  
  
  this.actualEditInput.classList.remove('hid');
  this.actualEditOpen = true;
  this.actualEditInput.focus();
  
  this.getId(this.actualEditInput.parentNode.getAttribute('expenseId'));
  this.actions.actual_tab = null;
}
if (this.actions.onInitTabAction && this.actions.target_tab !== null) {
  this.actions.onInitTabAction = false;
  this.actions.target_tab.rooftop++;
  this.actions.tableIndex++;
  if (this.actions.tableIndex === this.rooftops.length) {
    this.actions.tableIndex = 0;
  }
  
  if (this.actions.target_tab.sIndex !== undefined) {
    if (this.categories[this.actions.target_tab.cIndex].products[this.actions.target_tab.pIndex].subproducts[this.actions.target_tab.sIndex].expenses[this.actions.tableIndex].id === 0) return;
    this.actions.tableFieldId = this.categories[this.actions.target_tab.cIndex].products[this.actions.target_tab.pIndex].subproducts[this.actions.target_tab.sIndex].id;
    let title = this.rooftops[this.actions.target_tab.rooftop].title;
  

  this.editInput = document.getElementById(`${title}-${this.actions.tableFieldId}-input`);
  
  } else  {
    if (this.categories[this.actions.target_tab.cIndex].products[this.actions.target_tab.pIndex].expenses[this.actions.tableIndex].id === 0) return;
    this.actions.tableFieldId = this.categories[this.actions.target_tab.cIndex].products[this.actions.target_tab.pIndex].id;
let title = this.rooftops[this.actions.target_tab.rooftop].title;
 
    this.editInput = document.getElementById(`${title}-${this.actions.tableFieldId}-input`);
   
     }
 this.openedEdit = this.editInput.parentNode.querySelector('.target');

  let num = this.openedEdit.innerText.replace(/[^0-9\.]+/g, "");
  this.editInput.value = num;
  if (this.editInput.value === "0") {
    this.editInput.value = "";
  }
  
 
  
  this.editInput.classList.remove('hid');
  this.editOpen = true;
  this.editInput.focus();
  this.getId(this.openedEdit.parentNode.getAttribute('expenseId'));
  
  this.expenseIndexes = {
    category: this.actions.target_tab.cIndex,
    product: this.actions.target_tab.pIndex,
    campaign: this.actions.target_tab.sIndex,
    rooftop: this.actions.target_tab.rooftop
  }
  this.actions.target_tab = null;
}
}
  closedAddSubproduct() {
    this.elRef.nativeElement.querySelector('.add-subproduct').style.display = 'none';
    this.elRef.nativeElement.querySelector('.mask-confirm-add-subproduct').style.display = 'none';
  }
  ngAfterViewInit() {
    $(".editIcon").mouseover(() => {
    
    })
    window.addEventListener('keydown', (e) => {
      if (e.keyCode === 27 && this.editOpen) {
        this.editInput.classList.add('hid');
        this.editOpen = false;
        this.removeHover();
      }
      if (e.keyCode === 27 && this.actualEditOpen) {
        this.actualEditInput.classList.add('hid');
        this.actualEditOpen = false;
        this.removeHover();
      }
    })
    window.addEventListener("click", (event) => {
      let elm = <HTMLElement>event.target;
      if (this.editOpen === true && this.editInput !== undefined && this.editInput === elm) return;
      if (this.actualEditOpen === true && this.actualEditInput !== undefined && this.actualEditInput === elm) return;
      if (this.infoOpen) {
     
        return;

      }
      else if (elm.classList.contains('info') && this.editOpen === true) {
        if (this.editInput !== undefined) {
          this.editInput.classList.add('hid');
        }
      }
      else if (!elm.classList.contains('tg') && this.editOpen === true) {
        if (this.editInput !== undefined) {
          this.editInput.classList.add('hid');
        }
        this.editOpen = false;
        this.removeHover();
      
      }

      if (!elm.classList.contains('ac') && this.actualEditOpen === true) {
       
        this.actualEditInput.classList.add('hid');
        this.actualEditOpen = false;
        this.removeHover();
   
      }
      if (elm.classList.contains('dropzoneDiv') || elm.classList.contains('dz-hidden-input')) {
        return
      }
      
      this.dropzone.removeAllFiles();
      document.getElementById("darken").classList.add('hid');
      document.getElementById("uploadContainer").classList.add('hid');
      document.getElementById("uploadBody").classList.remove('hid');
      document.getElementById('fileName').classList.add('hid');
      document.getElementById('progressBody').classList.add('hid');
      this.actions.closeLargerEdit();
   
    })
    let colorNodes = document.querySelectorAll('.colorListItem');
    this.positionNodes(colorNodes);
    this.initDropzone();
  }
  removeHover() {
   
    let hovered = [].slice.call(document.getElementsByClassName('hover'));
    let text = [].slice.call(document.getElementsByClassName("hoveredText"))
    let hElm = [].slice.call(document.getElementsByClassName('hoverPlus'));
    let per = [].slice.call(document.getElementsByClassName('hoverPercent'));
    for (let i in hovered) {
      if (hovered[i]) {
        hovered[i].classList.remove('hover');
      }

    }
    for (let h in this.infoIcons) {
      if (this.infoIcons[h]) {
        this.infoIcons[h].classList.add('hid');
      }

    }

    if (hElm[0]) {
      hElm[0].classList.remove('hoverPlus');
    }
    if (per[0]) {
      per[0].classList.remove('hoverPercent');
    }
    for (let u in text) {
      if (text[u]) {
        text[u].classList.remove('hoveredText');
      }
    }
    /* text[0].classList.remove('hoveredText');
     text[1].classList.remove('hoveredText');
     text[2].classList.remove('hoveredText');*/
  }
  positionNodes(arr) {
    for (let i = 0; i < arr.length; i++) {
      if (i !== 0) {
        let left = 70 + (40 * (i - 1));
        arr[i].style.left = `${left}px`
      } else {
        arr[i].classList.add('selectedColor');
      }
    }
  }
 
  getPercent() {
    let arr = [];
    for (let i in this.rooftops) {
      arr.push(((this.data.grandTotal.dealerShips[this.rooftops[i].id] / this.data.grandTotal.targetBudget) * 100).toLocaleString('en'));
    }
    this.percentages = arr;
  }
  getActualTotals(d) {
    let Total = 0;
    let rooftops = [];
    for (let i in this.rooftops) {
      let total = 0;
      for (let j in d) {
        let num = parseFloat(d[j].expenses[i].actual.replace(/[^0-9\.]+/g, ""));
        total += num;
        Total += num;
      }
      rooftops.push(total)
    }
    let data = { actualTotal: Total, dealerTotals: rooftops }
    this.broadcaster.broadcast('actualBudgetTotals', data);
  }
  openEdit(e, id, subproducts, product_id, rooftop, cIndex, pIndex, sIndex) {

    if (e.target.parentNode.classList.contains("tableCell-disabled") || this.show === "actual") return;
    this.actions.target_tab = new Tab(e, id, subproducts, product_id, rooftop, cIndex, pIndex, sIndex);
   
    this.indexMediaCat = this.mediaCategories.findIndex(item => item === String(this.categories[cIndex].id));
   
    this.isMediaCat = (this.indexMediaCat > (-1)) ? true : false;
   
    if (this.isMediaCat) {
      if (subproducts) {
     
        this.oldValue = (this.categories[cIndex].products[pIndex].subproducts[sIndex]) ? this.categories[cIndex].products[pIndex].subproducts[sIndex].expenses[rooftop].expense : this.categories[cIndex].products[pIndex].expenses[rooftop].expense;

      }
      else {
        this.oldValue = this.categories[cIndex].products[pIndex].expenses[rooftop].expense;
      }

      this.actions.openWarning();
      return;
    }
   
    let close = false;
    if (this.editOpen) {
      if (e.target !== this.editInput && e.target === this.openedEdit) {
        close = true;
      }
      this.editOpen = false;
      this.removeHover();
      this.hover(e, "enter", product_id, rooftop, true, null);
      this.editInput.classList.add('hid');
      if (this.editInput.value === "0")
      {
        this.editInput.value = "";
      }
    }
   
    if (close) {
      return
    }
    if (subproducts) {
      if (e.srcElement) {
        this.openedEdit = e.srcElement;
      } else if (e.target) {
        this.openedEdit = e.target;
      }
     
      if (id && id > 0) {
        this.httpService.getExpense(parseInt(id)).subscribe((data:responseGetExpense) => {
          this.openedFlights = data.expense.flightDate;
          this.totalExpense = data.expense;
          this.getId(id);
        })
      }
     
      this.editInput = document.getElementById(`${this.rooftops[rooftop].title}-${this.categories[cIndex].products[pIndex].id}-input`);
      this.editInput.classList.remove('hid');
      this.editOpen = true;
      let num = this.openedEdit.innerText.replace(/[^0-9\.]+/g, "");
      this.editInput.value = num;
      this.editInput.focus();
      if (this.editInput.value === "0")
      {
        this.editInput.value = "";
      }
      this.actions.tableIndex = Number(this.editInput.getAttribute('tabindex'));
      this.actions.tableFieldId = (this.editInput.getAttribute('subproduct')) ? this.editInput.getAttribute('subproduct') : this.editInput.getAttribute('product');
    
      this.expenseIndexes = {
        category: cIndex,
        product: pIndex,
        campaign: sIndex,
        rooftop: rooftop
      }
      return
    } else {
      if (id && id > 0) {
        this.httpService.getExpense(parseInt(id)).subscribe((data:responseGetExpense) => {
          this.openedFlights = data.expense.flightDate;
          this.totalExpense = data.expense;
        })
      } else {
        this.openedFlights = [];
        this.totalExpense = 0;
      }
      if (sIndex !== undefined) {
        this.editInput = document.getElementById(`${this.rooftops[rooftop].title}-${this.categories[cIndex].products[pIndex].subproducts[sIndex].id}-input`);
       // this.categories[cIndex].products[pIndex].subproducts[sIndex]
      } else {
        this.editInput = document.getElementById(`${this.rooftops[rooftop].title}-${this.categories[cIndex].products[pIndex].id}-input`);
      }
      if (e.srcElement) {
        this.openedEdit = e.srcElement;
      } else if (e.target) {
        this.openedEdit = e.target;
      }
      let num = this.openedEdit.innerText.replace(/[^0-9\.]+/g, "");
      if (id === 0 || id === undefined) {
        this.create = true;
      } else {
        this.create = false;
      }
      if (num == 0) {
        this.editInput.value = '';
      } else {
        this.editInput.value = num;
      }
      this.editInput.classList.remove('hid');
      this.editOpen = true;
      this.editInput.focus();
      if (this.editInput.value === "0")
      {
        this.editInput.value = "";
      }
      this.actions.tableIndex = Number(this.editInput.getAttribute('tabindex'));
      this.actions.tableFieldId = (this.editInput.getAttribute('subproduct')) ? this.editInput.getAttribute('subproduct') : this.editInput.getAttribute('product');
    
      this.getId(id);
      this.expenseIndexes = {
        category: cIndex,
        product: pIndex,
        campaign: sIndex,
        rooftop: rooftop
      }
    
      /*if(sIndex !== undefined || !this.categories[cIndex].products[pIndex].subproducts){
        let editDealer = document.getElementById('editDealer');
        let editProduct = document.getElementById('editProduct');
        editDealer.innerHTML = this.rooftops[rooftop].title;
        if(sIndex !== undefined){
          editProduct.innerHTML = this.categories[cIndex].products[pIndex].subproducts[sIndex].title;
        }else{
          editProduct.innerHTML = this.categories[cIndex].products[pIndex].title;
        }
        let num = e.srcElement.parentElement.innerText.replace(/[^0-9\.]+/g,"");
        document.getElementById('editBox').classList.remove('hid');
        let input = <HTMLInputElement>document.getElementById('editInput');
        input.value = num;
        this.getId(rooftop, cIndex, pIndex, sIndex);
      }*/
    }
  }
  openActualEdit(e, id, subproducts, title, rooftop, cIndex, pIndex, sIndex) {
    let close = false;
    this.actions.actual_tab = new Tab(e, id, subproducts, title, rooftop, cIndex, pIndex, sIndex);
    if (this.actualEditOpen) {
      if (e.target !== this.editInput && e.target === this.openedEdit) {
        close = true;
      }
      this.actualEditOpen = false;
      this.removeHover();
      this.hover(e, "enter", title, rooftop, true, null);
      this.actualEditInput.classList.add('hid');
     
      if (this.actualEditInput.value === "0")
      {
        this.actualEditInput.value = "";
      }
    }
    if (close) {
      return
    }
    if (subproducts || id === 0) {
      return
    } else {
      if (sIndex !== undefined) {
        this.actualEditInput = document.getElementById(`${this.rooftops[rooftop].title}-${this.categories[cIndex].products[pIndex].subproducts[sIndex].id}-input-actual`);
      } else {
        this.actualEditInput = document.getElementById(`${this.rooftops[rooftop].title}-${this.categories[cIndex].products[pIndex].id}-input-actual`);
      }
      if (e.srcElement) {
        this.openedActualEdit = e.srcElement;
      } else if (e.target) {
        this.openedActualEdit = e.target;
      }
      let num = this.openedActualEdit.innerText.replace(/[^0-9\.]+/g, "");
      if (this.actualEditInput.value === "0")
      {
        this.actualEditInput.value = "";
      }
      if (id === undefined) {
        return
      }
      this.actualEditInput.value = num;
      this.actualEditInput.classList.remove('hid');
      this.actualEditOpen = true;
      this.actualEditInput.focus();
      if (this.actualEditInput.value === "0")
      {
        this.actualEditInput.value = "";
      }
      this.getId(id);
      this.expenseIndexes = {
        category: cIndex,
        product: pIndex,
        campaign: sIndex,
        rooftop: rooftop
      }
    }
  }
  getId(id) {
    this.expense.id = id;
    this.actualExpense.id = id;
  }

  setSummExpense(subproducts, index, dealerShipId) {
    let summ = new SummExpense(this.year,this.month,dealerShipId,this.categories[this.expenseIndexes.category].products[this.expenseIndexes.product].id,this.editInput.value,
      0);
      summ.setexpensesPercents(subproducts,index);
   
    this.httpService.setSummExpense(summ)
      .subscribe((data:responseUpdateExpensesProduct) => {
      
       
          this.categories = this.actions.updateCategoryAfterChangeSumm(this.categories, this.expenseIndexes, data, index, dealerShipId);
          this.editInput.classList.add('hid');
          this.editOpen = false;
       
          this.actions.convertType({categories: this.categories});
          this.getActualTotals(this.categories);
         
          let grandTotal:GrandTotal = this.actions.updateGrandTotal(this.categories,this.rooftops);
          this.broadcaster.broadcast('updateGrandTotal', grandTotal);
          this.broadcaster.broadcast('updateCategories', new updateCategories(this.categories));
          this.data.grandTotal = grandTotal;
          this.getPercent();
      });
  }
  submit(e, categoryId, expenseId, index) {
   
    if (e.key === "Enter" && this.editOpen) {
     
     
      if (!e.target.getAttribute("subproduct") && this.categories[this.expenseIndexes.category].products[this.expenseIndexes.product].subproducts) {
       if (this.categories[this.expenseIndexes.category].products[this.expenseIndexes.product].expenses[index].exist === false)
       {
        let value = parseInt(this.editInput.value);
        this.createExpense(value, expenseId, categoryId, index);
        return;
       }
       
        let subproducts = this.categories[this.expenseIndexes.category].products[this.expenseIndexes.product].subproducts;
        let countExistSub: number = 0;
        subproducts.forEach(element => {
          if (!element.expenses[index].exist) {
            countExistSub++;
          }
        });
        if (countExistSub === subproducts.length) {
       
          let value = parseInt(this.editInput.value);
          this.changeExpense(value);
          return;
        }
        if (subproducts.length === 1) {
          subproducts[0].expenses[index].percent = 100;
       
        }
        else {
      
          let priceProduct = 0;
          for (let u = 0; u < subproducts.length; u++) {
            priceProduct += subproducts[u].dealerShips[e.target.getAttribute('rooftop')].targetBudget;
          }

          for (let i = 0; i < subproducts.length; i++) {
            let priceSub = subproducts[i].dealerShips[e.target.getAttribute('rooftop')].targetBudget;
            subproducts[i].expenses[index].percent = (priceSub / priceProduct * 100);
          }
        }
        subproducts.map((item) => {
          item.expenses[index].actualBudgetPercent = item.expenses[index].percent;
          return item;
        })
       
        this.setSummExpense(subproducts, index, e.target.getAttribute('rooftop'));
        return;
      }


      this.httpService.getСategory(new requestGetCategory ({
        id: categoryId, dealerShipId: e.target.getAttribute('rooftop'),
        year: this.year, month: this.month
      }), (this.typeMonth) ? 'daysOfMonth' : 'monthsOfQuarter')
        .subscribe((res:responseGetСategory) => {
         
        

           
            this.addSubProduct.setData(expenseId,categoryId,index,res.category,e.target);
            if (!res.category) {
              let indexCat: number = this.categories.findIndex(item => item.id === categoryId);
              if (indexCat > (-1)) {

                this.addSubProduct.category = this.categories[indexCat];
                this.addSubProduct.noCat = true;
               this.actions.onInitAddComapin();
                this.expenseIndexes.rooftop = this.rooftops.findIndex(item => Number(item.id) === Number(e.target.getAttribute('rooftop')));
                this.addSubProduct.subproduct = (e.target.getAttribute('subproduct')) ? true : false;
                return;

              }

            }
            let indexProd: number = this.addSubProduct.category.products.findIndex(item => String(item.id) === String(e.target.getAttribute('product')));
           
            this.addSubProduct.indexProd = indexProd;
            if (indexProd > (-1)) {
              if (!e.target.getAttribute('subproduct')) {
                if (this.create === true) {
                  let value = parseInt(this.editInput.value);
                  this.createExpense(value, expenseId, categoryId, index);

                } else {
                  let value = parseInt(this.editInput.value);
                  this.changeExpense(value);
                }
                if (e.key === "Tab")
                {
                  this.actions.onInitTabKey = e;
                 
                  this.actions.onInitTabAction = true;
                  this.broadcaster.broadcast("showPreloaderBudget", null);
                 // this.actions.onInitTab(e,this.rooftops,false);
                }
                return;

              }

              if (this.addSubProduct.category.products[this.addSubProduct.indexProd].subproducts) {
                let indexSubProd: number = this.addSubProduct.category.products[this.addSubProduct.indexProd].subproducts.findIndex(item => String(item.id) === String(this.addSubProduct.event.getAttribute('subproduct')));
                if (indexSubProd > (-1)) {


                  let value = parseInt(this.editInput.value);
                  this.changeExpense(value);
                  if (e.key === "Tab")
                  {
                    this.actions.onInitTabKey = e;
                 
                    this.actions.onInitTabAction = true;
                    this.broadcaster.broadcast("showPreloaderBudget", null);
                   // this.actions.onInitTab(e,this.rooftops,false);
                  }
                  return;
                }

              }

              this.addSubProduct.subproduct = true;

this.actions.onInitAddComapin();
             

            }
            else {
              this.addSubProduct.subproduct = false;
              this.actions.onInitAddComapin();
            
            }
          


        });
    } else if (e.key === "Enter" && this.actualEditOpen) {
      let value = parseInt(this.actualEditInput.value);
    let indexCat:number = this.categories.findIndex(item => item.id === categoryId);
     if (indexCat > -1)
     {
      
      let indexProd:number = this.categories[indexCat].products.findIndex(item => item.id ===  Number(this.actualEditInput.getAttribute("product")));
    
      if (indexProd > -1)
      {
        if (this.categories[indexCat].products[indexProd].subproducts)
        {
          this.actions.tableIndex = Number(this.actualEditInput.getAttribute('tabindex'));
          this.actions.tableFieldId = (this.actualEditInput.getAttribute('subproduct')) ? this.actualEditInput.getAttribute('subproduct') : this.actualEditInput.getAttribute('product');
        
         let indexSubProd:number = Number(this.actualEditInput.getAttribute("subproductindex"));
        if ( this.categories[indexCat].products[indexProd].subproducts[indexSubProd].dealerShips)
      {
        this.categories[indexCat].products[indexProd].subproducts[indexSubProd].dealerShips[this.actualEditInput.getAttribute("rooftop")].actualBudget = value;
      }
        
         this.categories[indexCat].products[indexProd].subproducts[indexSubProd].expenses[index].setActual(value);
        

        } else {
          this.actions.tableIndex = Number(this.actualEditInput.getAttribute('tabindex'));
          this.actions.tableFieldId = (this.actualEditInput.getAttribute('subproduct')) ? this.actualEditInput.getAttribute('subproduct') : this.actualEditInput.getAttribute('product');
        
         if ( this.categories[indexCat].products[indexProd].dealerShips)
         {
          this.categories[indexCat].products[indexProd].dealerShips[this.actualEditInput.getAttribute("rooftop")].actualBudget = value;
         }
       
          this.categories[indexCat].products[indexProd].expenses[index].setActual(value);
         
        }
      
       
      }
     
     }
      this.actualEditInput.classList.add('hid');
       // this.actualEditOpen = false;
       if (e.key === "Tab")
       {
         this.actions.onInitTabKey = e;
       
         this.actions.onInitTabAction = true;
           this.broadcaster.broadcast("showPreloaderBudget", null);
        // this.actions.onInitTab(e,this.rooftops,false);
       }
       this.removeHover();
      this.changeActual(value);
     
    }


  }
  ConfirmAddSubProduct() {
    let value = parseInt(this.editInput.value);
    if (this.addSubProduct.noCat) {
      let camp;
    
      if (this.addSubProduct.subproduct) {
        camp = this.categories[this.expenseIndexes.category].products[this.expenseIndexes.product].subproducts[this.expenseIndexes.campaign].title;

      } else {
        camp = ""
      }
      this.closedAddSubproduct();

      let expense: Expense = new Expense();
      expense.onInitDefault(this.categories[this.expenseIndexes.category].products[this.expenseIndexes.product].id,this.categories[this.expenseIndexes.category].id);
      expense.month = this.month;
      expense.year = this.year;
      expense.dealerShipId = this.rooftops[this.expenseIndexes.rooftop].id;
      expense.targetBudget = value;
      expense.campaign = camp;
      this.httpService.addExpense(expense).subscribe((data:responseAddExpense) => {
        this.broadcaster.broadcast("updateBudget",null);
      }, (error) => {
       

      });
      return;
    }

    if (this.addSubProduct.subproduct) {
      let indexSubProd: number = (-1);
      if (this.addSubProduct.category.products[this.addSubProduct.indexProd].subproducts) {
        indexSubProd = this.addSubProduct.category.products[this.addSubProduct.indexProd].subproducts.findIndex(item => String(item.id) === String(this.addSubProduct.event.getAttribute('subproduct')));

      }

      this.closedAddSubproduct();
      if (indexSubProd === (-1) && this.addSubProduct.indexProd === (-1) || indexSubProd === (-1) && this.addSubProduct.category.products[this.addSubProduct.indexProd].subproducts) {
        this.expenseIndexes.rooftop = this.rooftops.findIndex(item => Number(item.id) === Number(this.addSubProduct.event.getAttribute('rooftop')));
        let value = parseInt(this.editInput.value);
        this.createExpense(value, this.addSubProduct.expenseId, this.addSubProduct.categoryId, this.addSubProduct.index);

        return;
      }

    
      let value = parseInt(this.editInput.value);
      let data = {
        id: (indexSubProd > (-1)) ? this.addSubProduct.category.products[this.addSubProduct.indexProd].subproducts[indexSubProd].expenses[0].id : this.addSubProduct.category.products[this.addSubProduct.indexProd].expenses[0].id,
        targetBudget: value,
        actualBudget: 0,
        flightDate: [],
        campaign: this.categories[this.expenseIndexes.category].products[this.expenseIndexes.product].subproducts[this.expenseIndexes.campaign].title,
        strategy: "",
        description: "",
        notes: "",
        coop: 0,
        creativeId: ""
      };
      this.httpService.saveExpense(data)
        .subscribe((data:responseSaveExpense) => {
          this.editOpen = true;

            this.getDataEvent.next();
      
        });
    }
    else {
      let value = parseInt(this.editInput.value);
      this.closedAddSubproduct();
      this.createExpense(value, this.addSubProduct.expenseId, this.addSubProduct.categoryId, this.addSubProduct.index);
    }

  }
  createExpense(value, productId, categoryId, index) {
    let camp;
    
    if (this.expenseIndexes.campaign !== undefined) {
      camp = this.categories[this.expenseIndexes.category].products[this.expenseIndexes.product].subproducts[this.expenseIndexes.campaign].title;
 
    } else {
      camp = ""
    }
    let expense: Expense = new Expense();
    expense.onInitDefault(this.categories[this.expenseIndexes.category].products[this.expenseIndexes.product].id,this.categories[this.expenseIndexes.category].id);
    expense.month = this.month;
    expense.year = this.year;
    expense.dealerShipId = this.rooftops[this.expenseIndexes.rooftop].id;
    expense.targetBudget = value;
    expense.campaign = camp;
     this.httpService.addExpense(expense).subscribe((data:responseAddExpense) => {
      this.broadcaster.broadcast("updateBudget", null);
    }, (error) => {
     

    });
  }
  changeExpense(value) {
    let dataUpdate = this.expense;
    
    dataUpdate.targetBudget = parseFloat(value);
    this.newValue = value;
    this.oldValue = this.totalExpense.targetBudget;
    this.updateData = dataUpdate;
    if (this.openedFlights.length > 1) {
      this.flightNum = this.openedFlights.length;
      this.actions.openWarning();
      
     

    } else {
     
      this.editInput.classList.add('hid');
    //  this.editOpen = false;
      this.updateExpense();
    }

  }
 
  closedWarning() {
    document.querySelector(".flightWarning").classList.add('hid');
    document.querySelector(".darken").classList.add('hid');
  }
  updateExpense() {
    
    document.querySelector(".flightWarning").classList.add('hid');
    document.querySelector(".darken").classList.add('hid');
    this.httpService.updateTargetBudget(this.updateData).subscribe((data:responseUpdateTargetBudget) => {
      this.actions.updateExpense(this.categories,this.expenseIndexes,this.rooftops,data.expense);
      let grandTotal:GrandTotal = this.actions.updateGrandTotal(this.categories,this.rooftops);
      this.broadcaster.broadcast('updateGrandTotal', grandTotal);
      this.broadcaster.broadcast('updateCategories', new updateCategories(this.categories));
      this.data.grandTotal = grandTotal;
      this.getPercent();
     // this.getDataEvent.next();
    });
  }
  changeActual(value) {
   
    let dataUpdate = this.actualExpense;
    dataUpdate.actualBudget = parseFloat(value);
    this.httpService.updateActualBudget(dataUpdate).subscribe((data:responseActualBudget) => {
    
      this.actions.updateExpense(this.categories,this.expenseIndexes,this.rooftops,data.expense);
      let grandTotal:GrandTotal = this.actions.updateGrandTotal(this.categories,this.rooftops);
      this.broadcaster.broadcast('updateGrandTotal', grandTotal);
      this.broadcaster.broadcast('updateCategories', new updateCategories(this.categories));
      this.data.grandTotal = grandTotal;
      this.getPercent();
      this.getActualTotals(this.categories);
     
    //  this.getDataEvent.next();
    });
  }
  infoSelected() {
    document.querySelector(".flightWarning").classList.add('hid');
    document.querySelector(".darken").classList.add('hid');
    let cTitle = this.categories[this.expenseIndexes.category].title;
    let pTitle = this.categories[this.expenseIndexes.category].products[this.expenseIndexes.product].title;
    this.openInfo(null, this.totalExpense.id, this.rooftops[this.expenseIndexes.rooftop].id, this.expenseIndexes.product, this.expenseIndexes.category, cTitle, pTitle, null)
  }
  scrolling(event:any) {
    this.scrollEvent.next();
  }
  mouseOver(event:any) {
    this.mouseEvent.next();
  }
  hover(e, type, id, index, click, m) {
    if (e.target.parentNode.classList.contains("tableCell-disabled")) return;
    let target;
    if (click) {
      target = e.target.parentElement;
    } else {
      target = e.target;
    }

    let elements = document.querySelectorAll(`[selector="${id}-expense"]`);
    let over = document.getElementById(`${this.rooftops[index].title}-${id}-over`);
    let i = document.getElementById(`${this.rooftops[index].title}-${id}-i`);
    let circle = document.getElementById(`${this.rooftops[index].title}-${id}-circle`);
    let dealerElements = [].slice.call(document.querySelectorAll(`[dealer="${this.rooftops[index].title}"]`));
    let textElms = [].slice.call(document.querySelectorAll(`[selector="${id}-text"]`));
    let percent = document.getElementById(`${this.rooftops[index].title}-percent`);
    if (type === 'enter' && (!this.editOpen && !this.actualEditOpen)) {
      let elmIndex;
      if (target.classList.contains('target') || target.classList.contains('actual')) {
        elmIndex = dealerElements.indexOf(target.parentElement);
      } else {
        elmIndex = dealerElements.indexOf(target);
      }
      if (over !== null && circle !== null && i !== null && this.show === "target") {
        over.classList.remove('hid');
        circle.classList.remove('hid');
        i.classList.remove('hid');
      }
      if (document.getElementById(`${id}-line`))
      {
        document.getElementById(`${id}-line`).classList.add('hover');
      }
    
      for (let i = 0; i < index; i++) {
        if (elements[i])
        {
          elements[i].classList.add('hover');
        }
      
      }
      for (let i = 0; i < elmIndex; i++) {
        dealerElements[i].classList.add('hover');
      }
      for (let i in textElms) {
        textElms[i].classList.add('hoveredText');
      }
      if (elements[index])
      {
        elements[index].classList.add('hoverPlus');
      }
    
      percent.classList.add('hoverPercent');
      this.dealerHover = elmIndex;
      this.infoIcons = [over, i, circle];
    } else if (type === 'exit' && (this.editOpen === false && this.actualEditOpen === false)) {

      document.getElementById(`${id}-line`).classList.remove('hover');
      for (let i = 0; i < index; i++) {
        elements[i].classList.remove('hover');
      }
      for (let i = 0; i < this.dealerHover; i++) {
        dealerElements[i].classList.remove('hover');
      }
      for (let i in textElms) {
        textElms[i].classList.remove('hoveredText');
      }
      if (over !== null && circle !== null && i !== null && this.show === "target") {
        over.classList.add('hid');
        circle.classList.add('hid');
        i.classList.add('hid');
      }
      elements[index].classList.remove('hoverPlus');
      percent.classList.remove('hoverPercent');
    }
  }
  showActual() {
    let actual = [].slice.call(document.getElementsByClassName('actual'));
    let target = [].slice.call(document.getElementsByClassName('target'));
    if (this.show === "target") {
      for (var i = 0; i < actual.length; i++) {
        actual[i].classList.remove("hid");
        actual[i].classList.add("showing");
        if (target[i]) {
          target[i].classList.add("hid");
        }
      }
      this.show = "actual";
    } else if (this.show === "actual") {
      for (var i = 0; i < actual.length; i++) {
        actual[i].classList.add("hid");
        actual[i].classList.remove("showing");
        if (target[i]) {
          if (!target[i].classList.contains('tg')) {
            target[i].classList.remove("hid");
          }
        }
      }
      this.show = "target";
    }
  }
  dragover(e) {
    e.stopPropagation();
    e.preventDefault();
  }
  drop(e) {
    e.stopPropagation();
    e.preventDefault();
    this.file = e.dataTransfer.files[0];
  }
  getInvoiceNum(e, id) {
    /*this.httpService.getExpense(parseInt(id)).subscribe(data=>{

    })*/
  }
  openUpload(id) {
    if (id === 0) {
      return
    } else {
      this.httpService.getExpense(parseInt(id)).subscribe((data:responseGetExpense) => {
        this.actualExpenseOpen = data.expense;
        this.indexFolder = this.actualExpenseOpen.folders.findIndex(item => item.folderId === -1);
        if (this.actualExpenseOpen.folders[this.indexFolder].files.length > 0) {
          this.actions.openLargerEdit();
          this.fileName()
        }
        document.getElementById("darken").classList.remove('hid');
        document.getElementById("uploadContainer").classList.remove('hid');
        $(".dropzoneRight").attr("action", `/api/files/upload?expenseId=${this.actualExpenseOpen.id}&folderId=-1`);
        this.dropzone.options.url = `/api/files/upload?expenseId=${this.actualExpenseOpen.id}&folderId=-1`;

      })
    }

  }
  fileName() {
   
    for (let i of this.actualExpenseOpen.folders[this.indexFolder].files) {
      let time = parseInt(i.filename.split("-").pop());
      let date = new Date(time);
      let month = date.getUTCMonth() + 1; //months from 1-12
      let day = date.getUTCDate();
      let year = date.getUTCFullYear();
      let newdate:string = month + "/" + day + "/" + year;
     // i.date = newdate;
      i.filename = i.filename.replace('dollarsign-', '$');
      let arr = i.filename.split('-');
      arr.splice(-1, 1);
      i.filename = arr.join(' ');
      i.filename = `${i.filename}.${i.extension}`;
    }
  }
  deleteFile(fileid, index) {
    let data:DeleteFileExpense = new DeleteFileExpense(this.actualExpenseOpen.id,fileid);
    this.httpService.removeFileExpense(fileid).subscribe((res:responseRemoveFileExpense) => {
     if (this.actualExpenseOpen.folders[this.indexFolder].files.length === 1)
     {
     this.actions.setExistFiles(this.actualExpenseOpen,this.categories,false);
     }
      this.actualExpenseOpen.folders[this.indexFolder].files.splice(index, 1);
      this.elRef.nativeElement.querySelector(`.tableCell[expenseId="${this.actualExpenseOpen.id}"] .actual`).classList.remove("hid");
    })
  }

 
 
  initDropzone() {
    let main = this;
    this.dropzone = new Dropzone(".dropzoneRight", {
      url: `/api/files/upload`,
      autoProcessQueue: false,
      sending: function (file, xhr, formData) {
        document.getElementById('fileName').classList.add('hid');
        document.getElementById('progressBody').classList.remove('hid');
        formData.append("uploadedFile", file, main.filename);
      },
      complete: function () {
        main.uploading = false;
        main.httpService.getExpense(main.actualExpenseOpen.id).subscribe((data:responseGetExpense) => {
          main.actualExpenseOpen = data.expense;
          if (main.actualExpenseOpen.folders[main.indexFolder].files.length > 0) {
            main.fileName();
            main.actions.openLargerEdit();
            document.getElementById("dropzone").classList.remove('hid');
            document.getElementById("dropzone").classList.remove('shorter');
            document.getElementById("uploadBody").classList.remove('hid');
            document.getElementById('progressBody').classList.add('hid');
            main.actions.setExistFiles(main.actualExpenseOpen,main.categories,true);
           main.elRef.nativeElement.querySelector(`.tableCell[expenseId="${main.actualExpenseOpen.id}"] .actual`).classList.remove("hid");
          }
        })
      },
      uploadprogress: function (file, progress, bytesSent) {
        let b = main.dropzone.files[0].size / 100000000;
        let p = (b * progress).toFixed(2);
        main.actions.changeProgress(p, progress);
      },
      addedfile: function (file) {
        main.uploading = true;
        document.getElementById("uploadBody").classList.add('hid');
        document.getElementById('fileName').classList.remove('hid');
        main.actions.closeLargerEdit()
        setTimeout(() => {
          let ex = file.upload.filename.split(".").pop();
          let size = (file.size / 1000000).toFixed(2);
          let name = file.upload.filename.split(".").shift();
          let exText = document.getElementById('extension');
          let sizeText = document.getElementById('fileSize');
          let inputElement = <HTMLInputElement>document.getElementById('fileNameInput');
          inputElement.value = name;
          exText.innerHTML = ex;
          sizeText.innerHTML = size;
        }, 50)
      },
      thumbnail: function (file, dataUrl) {
       
      },
      error: function (errorMessage) {
        
        let Errors = JSON.parse(errorMessage.xhr.response);
      },
    });
    this.dropzone.handleFiles = function (files) {
      let main = this;
      var files_array = [];

      for (var i = 0; i < files.length; i++) {
        files_array.push(files[i]);
      }

      return files_array.map(function (file) {
        return main.addFile(file);
      })
    }
    $("#submit").click(() => {
      let inputElement = <HTMLInputElement>document.getElementById('fileNameInput');
      let ex = this.dropzone.files[0].upload.filename.split(".").pop();
      let value = inputElement.value;
      let sentName = document.getElementById('sentName');
      let date = new Date().getTime();
      this.filename = `${value}-${date}.${ex}`;
      this.filename = this.filename.replace(/\$/g, '-dollarsign-');
      sentName.innerHTML = `${value}.${ex}`;
      this.dropzone.processQueue();
    });
    $("#close").click(() => {
      this.dropzone.removeAllFiles();
      document.getElementById("darken").classList.add('hid');
      document.getElementById("uploadContainer").classList.add('hid');
      document.getElementById("uploadBody").classList.remove('hid');
      document.getElementById('fileName').classList.add('hid');
      document.getElementById('progressBody').classList.add('hid');
      this.actions.closeLargerEdit();
    /*  if (this.actualExpenseOpen)
      {
        this.elRef.nativeElement.querySelector(`.tableCell[expenseId="${this.actualExpenseOpen.id}"] .actual`).classList.remove("hid");
      }*/
     
    })
    $("#refresh").click(() => {
      let name = this.dropzone.files[0].upload.filename.split(".").shift();
      let inputElement = <HTMLInputElement>document.getElementById('fileNameInput');
      inputElement.value = name;
    })
  }
  onChangeColor(e) {
    let arr = e.split('#');
    this.colors.color = arr[1];
  }
  onColorPickerClose(e) {
    if (e) {
      this.pickerOpen = true;
    } else {
      /*let nodes = document.querySelectorAll('.colorListItem');
      for (let i = 0; i < nodes.length; i++) {
        nodes[i].classList.remove('selectedColor');
      }*/
      this.colors.list.unshift(`#${this.colors.color}`);
      this.colors.list.splice(this.colors.list.length - 1, 1);
      this.pickerOpen = false;

      /*  setTimeout(() => {
          let colorNodes = document.querySelectorAll('.colorListItem');
          console.log(colorNodes)
          this.positionNodes(colorNodes)
        }, 1)*/
    }
  }
  OpenMediaCalendar() {
    //  this.broadcaster.broadcast("showPreloaderBudget", null);
    this.elRef.nativeElement.querySelector('#preloader').style.display = 'block';
    this.elRef.nativeElement.querySelector('#preloader-mask').style.display = 'block';
    window.localStorage.setItem("media_category_id", this.mediaCategories[this.indexMediaCat]);
    window.location.href = `/rtb?id=${window.localStorage.getItem("clientId")}`;

  }
  setColor(index) {
    this.selectedColor = index;
    /*  let colorNodes = document.querySelectorAll('.colorListItem');*/
    this.color = this.colors.list[index];
    this.colors.color = this.colors.list[index].split('#')[1];
    /* for (let i = 0; i < colorNodes.length; i++) {
       colorNodes[i].classList.remove('selectedColor');
     }
     colorNodes[index].classList.add('selectedColor');*/
  }
  saveCategory(e) {
    let data = {
      color: this.color
    }
    this.broadcaster.broadcast("saveCategory", data);
  }
  openInfo(e, id, dealerShip, pId, cId, pTitle, cTitle, index) {
    if (e.target.parentNode.classList.contains("tableCell-disabled") || this.show === "actual") return;
    this.editOpen = true;
    this.infoOpen = true;
    for (let i of this.infoIcons) {
      if (i) {
        i.classList.add('orange');
      }

    }
    let title;
    if (cTitle) {
      title = cTitle
    } else {
      title = pTitle
    }
    if (id || id > 0) {
      this.httpService.getExpense(parseInt(id)).subscribe((data:responseGetExpense) => {
        this.broadcaster.broadcast("openInfoBudget", {data:data.expense});
      })
    } else {
      let data = {
        makeNew: true,
        dealerShipId: dealerShip,
        productId: pId,
        categoryId: cId,
        productTitle: pTitle,
        campaign: cTitle
      }
      this.broadcaster.broadcast("openInfoBudget", data)
    }
    this.actions.onInitEditExpense(index,String(id),e);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/budget/right-panel/right-panel.component.ts